"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.workflowWebSearch = exports.workflowWebSearchResultSchema = exports.workflowWebSearchArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
// Argument schema
exports.workflowWebSearchArgsSchema = zod_1.z.object({
    query: zod_1.z.string().describe('required: The search query for web search'),
    text: zod_1.z
        .boolean()
        .describe('optional: Whether to include full text content in results, default is true')
        .nullish()
        .default(true),
    numResults: zod_1.z
        .number()
        .describe('optional: Number of results to return, default is 10')
        .nullish()
        .default(10),
    highlights: zod_1.z
        .boolean()
        .describe('optional: Whether to include highlights in results, default is false')
        .nullish()
        .default(false),
    useAutoprompt: zod_1.z
        .boolean()
        .describe('optional: Whether to use auto-prompt for query enhancement, default is false')
        .nullish()
        .default(false),
    emitMode: common_1.emitModeSchema.default('multi').describe('Emit mode for the tool. Default to "multi".'),
    options: zod_1.z
        .object({
        failIfEmpty: zod_1.z
            .boolean()
            .default(true)
            .describe('Fail if the search returns no results. Default to true.'),
    })
        .describe('Search options'),
});
// Result schema
exports.workflowWebSearchResultSchema = zod_1.z.object({
    results: zod_1.z
        .array(zod_1.z.object({
        title: zod_1.z.string().describe('The title of the web page from the search result'),
        url: zod_1.z.string().describe('The URL of the web page from the search result'),
        snippet: zod_1.z.string().describe('A short snippet/summary of the web page content'),
        text: zod_1.z
            .string()
            .nullish()
            .describe('The full text content of the web page, may be truncated based on maxTextLength parameter'),
        highlights: zod_1.z
            .array(zod_1.z.string())
            .nullish()
            .describe('Highlighted portions of the content that match the search query'),
    }))
        .describe('Array of search results from the Exa web search'),
});
// Tool definition
exports.workflowWebSearch = (0, common_1.createEmitModeToolMetadata)({
    id: 'workflowWebSearch',
    displayName: 'Web Search',
    displayDescription: 'Search the web with Exa for information about a query',
    category: 'search',
    color: common_1.BRAND_COLORS.EXA,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.EXA),
    icon: 'search',
    argsSchema: exports.workflowWebSearchArgsSchema,
}, exports.workflowWebSearchResultSchema);
